import React from 'react';
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faSave, 
    faTimes, 
    faSearch, 
    faFilter, 
    faCheck, 
    faCheckCircle,
    faTimesCircle,
    faFileInvoice,
    faNotesMedical,
    faSync,
    faChevronLeft,
    faChevronRight,
    faChevronDown,
    faChevronUp,
    faEye,
    faClipboardCheck,
    faExclamationCircle,
    faClose,
    faExclamationTriangle
} from '@fortawesome/free-solid-svg-icons';
import { DefaultLayout } from '../../layout/theme-customizer';
import Ordenes from '../ordenes/Index';

const id = window.location.pathname.split('/').pop()
const defaultLayout = Object.keys(DefaultLayout);
const layout = id ? id : defaultLayout

class FacturarArchivo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showModalOrden: false,
            ordenSeleccionada: null,
            busqueda: '',
            eps: '',
            regimen: '',
            estado: '',
            fecha_desde: '',
            fecha_hasta: '',
            revisado: '',
            
            archivos: [],
            total: 0,
            pagina_actual: 1,
            por_pagina: 50,
            ultima_pagina: 1,
            cargando: false,
            
            expandedRows: [], // para controlar qué archivos están expandidos
            
            ordenesSeleccionadas: this.cargarSeleccionadasStorage(),
            showModalRevision: false,
            ordenActual: null,
            notaRevision: '',
            epsSeleccionada: null,
            
            showModalFacturacion: false,
            epsFacturacion: '',
            regimenFacturacion: '',
            planFacturacion: '',
            modalidadFacturacion: '',
            facturando: false,
            
            empresas: [],
            regimenes: [],
            planes: [],
            modalidades: [],
            
            warningMessage: '',
            errores: []
        };
    }

    // Alertas
    mostrarAlerta = (icono, titulo, texto, timer = 2000) => {
        return Swal.fire({
            icon: icono, title: titulo, text: texto, timer: timer, timerProgressBar: true,
            showConfirmButton: true, confirmButtonText: 'Entendido',
            didOpen: () => {
                const container = document.querySelector('.swal2-container');
                if (container) container.style.zIndex = '2050';
            }
        });
    };

    mostrarConfirmacion = async (titulo, texto, icono = 'warning') => {
        return await Swal.fire({
            title: titulo, text: texto, icon: icono, showCancelButton: true,
            confirmButtonColor: '#d33', cancelButtonColor: '#3085d6',
            confirmButtonText: 'Sí, continuar', cancelButtonText: 'Cancelar',
            reverseButtons: true,
            didOpen: () => {
                const container = document.querySelector('.swal2-container');
                if (container) container.style.zIndex = '2050';
            }
        });
    };

    mostrarLoading = (titulo = 'Procesando...', texto = 'Por favor espere') => {
        Swal.fire({
            title: titulo, text: texto, allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
                const container = document.querySelector('.swal2-container');
                if (container) container.style.zIndex = '2050';
            }
        });
    };
    cerrarLoading = () => Swal.close();

    // Storage
    cargarSeleccionadasStorage = () => {
        try {
            const guardadas = localStorage.getItem('ordenesSeleccionadasFacturarArchivoes');
            if (guardadas) {
                const data = JSON.parse(guardadas);
                if (data.eps && Array.isArray(data.ids)) {
                    setTimeout(() => this.setState({ epsSeleccionada: data.eps }), 0);
                    return data.ids;
                }
            }
            return [];
        } catch (error) {
            return [];
        }
    };

    guardarSeleccionadasStorage = (seleccionadas, eps) => {
        try {
            localStorage.setItem('ordenesSeleccionadasFacturarArchivoes', JSON.stringify({ ids: seleccionadas, eps: eps }));
            this.setState({ epsSeleccionada: eps });
        } catch (error) {}
    };

    componentDidMount() {
        this.cargarArchivos();
    }

    cargarArchivos = async (pagina = 1) => {
        this.setState({ cargando: true, warningMessage: '' });
        try {
            const params = {
                busqueda: this.state.busqueda,
                eps: this.state.eps,
                regimen: this.state.regimen,
                estado: this.state.estado,
                fecha_desde: this.state.fecha_desde,
                fecha_hasta: this.state.fecha_hasta,
                pagina: pagina,
                por_pagina: this.state.por_pagina
            };

            if (this.state.revisado) params.revisado = this.state.revisado;
            Object.keys(params).forEach(key => {
                if (params[key] === '' || params[key] === null || params[key] === undefined) delete params[key];
            });

            const response = await authAxios.post('/ordenes/mostrar_archivos_facturar', params);
            
            if (response.data.success) {
                const nuevosArchivos = response.data.data;
                this.setState({
                    archivos: nuevosArchivos,
                    total: response.data.total,
                    pagina_actual: response.data.pagina_actual,
                    ultima_pagina: response.data.ultima_pagina,
                    empresas: response.data.empresas || [],
                    regimenes: response.data.regimenes || [],
                    planes: response.data.planes || [],
                    modalidades: response.data.modalidades || [],
                });
            }
        } catch (error) {
            this.mostrarAlerta('error', 'Error', 'No se pudieron cargar los archivos');
        } finally {
            this.setState({ cargando: false });
        }
    };

    mostrarAdvertencia = (mensaje) => {
        this.setState({ warningMessage: mensaje });
        setTimeout(() => this.setState({ warningMessage: '' }), 5000);
    };

    handleFilterChange = (e) => this.setState({ [e.target.name]: e.target.value });
    verOrdenModal = (archivo) => {
        window.localStorage.setItem("Archivo", 200);
        window.localStorage.setItem("TablaId", archivo.id);
        
        this.setState({
            showModalOrden: true,
            ordenSeleccionada: archivo
        });
    };

    cerrarModalOrden = () => {
        this.setState({
            showModalOrden: false,
            ordenSeleccionada: null
        });
        this.cargarArchivos(this.state.pagina_actual);
    };

    limpiarFiltros = () => this.setState({ busqueda: '', eps: '', regimen: '', estado: '', fecha_desde: '', fecha_hasta: '', revisado: '' }, () => this.cargarArchivos(1));
    buscar = () => this.cargarArchivos(1);
    cambiarPagina = (nuevaPagina) => {
        if (nuevaPagina >= 1 && nuevaPagina <= this.state.ultima_pagina) this.cargarArchivos(nuevaPagina);
    };

    getNombreEmpresa = (id) => {
        const empresa = this.state.empresas.find(e => e.id == id);
        return empresa ? empresa.nombre : `EPS ${id}`;
    };

    toggleRow = (id) => {
        this.setState(prevState => {
            const expandedRows = prevState.expandedRows.includes(id) 
                ? prevState.expandedRows.filter(rowId => rowId !== id)
                : [...prevState.expandedRows, id];
            return { expandedRows };
        });
    };

    puedeSeleccionarOrden = (eps_archivo) => {
        const { ordenesSeleccionadas, epsSeleccionada } = this.state;
        if (ordenesSeleccionadas.length === 0) return true;
        return eps_archivo === epsSeleccionada;
    };

    toggleSeleccionOrden = (orden_id, eps_archivo, porcentaje) => {
        if (porcentaje < 100) {
            this.mostrarAdvertencia('Solo se pueden seleccionar órdenes completadas al 100%');
            return;
        }

        this.setState(prevState => {
            let seleccionadas;
            let nuevaEpsSeleccionada = prevState.epsSeleccionada;

            if (!prevState.ordenesSeleccionadas.includes(orden_id)) {
                if (!this.puedeSeleccionarOrden(eps_archivo)) {
                    this.mostrarAdvertencia(`Solo puede seleccionar órdenes de la EPS ${this.getNombreEmpresa(prevState.epsSeleccionada)}`);
                    return prevState;
                }
                seleccionadas = [...prevState.ordenesSeleccionadas, orden_id];
                if (prevState.ordenesSeleccionadas.length === 0) {
                    nuevaEpsSeleccionada = eps_archivo;
                }
            } else {
                seleccionadas = prevState.ordenesSeleccionadas.filter(id => id !== orden_id);
                if (seleccionadas.length === 0) {
                    nuevaEpsSeleccionada = null;
                }
            }
            this.guardarSeleccionadasStorage(seleccionadas, nuevaEpsSeleccionada);
            return { ordenesSeleccionadas: seleccionadas, epsSeleccionada: nuevaEpsSeleccionada };
        });
    };

    limpiarSeleccion = () => {
        this.setState({ ordenesSeleccionadas: [], epsSeleccionada: null });
        localStorage.removeItem('ordenesSeleccionadasFacturarArchivoes');
    };

    abrirModalFacturacion = () => {
        if (this.state.ordenesSeleccionadas.length === 0) {
            this.mostrarAlerta('warning', 'Atención', 'Debe seleccionar al menos una orden para facturar');
            return;
        }
        this.setState({
            showModalFacturacion: true,
            epsFacturacion: this.state.epsSeleccionada || this.state.eps || '',
            regimenFacturacion: this.state.regimen || '',
            planFacturacion: '',
            modalidadFacturacion: ''
        });
    };

    cerrarModalFacturacion = () => this.setState({ showModalFacturacion: false, facturando: false });

    handleEpsFacturacionChange = async (e) => {
        const nuevaEps = e.target.value;
        const { ordenesSeleccionadas, epsSeleccionada } = this.state;
        
        if (ordenesSeleccionadas.length > 0) {
            if (nuevaEps && epsSeleccionada && nuevaEps !== epsSeleccionada) {
                this.cerrarModalFacturacion();
                const result = await this.mostrarConfirmacion(
                    '¿Cambiar EPS?',
                    `Las órdenes seleccionadas son de ${this.getNombreEmpresa(epsSeleccionada)}. Si cambia la EPS, se limpiará la selección actual.`
                );
                if (result.isConfirmed) {
                    this.limpiarSeleccion();
                    this.setState({ showModalFacturacion: true, epsFacturacion: nuevaEps });
                } else {
                    this.setState({ showModalFacturacion: true, epsFacturacion: epsSeleccionada });
                }
                return;
            }
        }
        this.setState({ epsFacturacion: nuevaEps });
    };

    revisarOrden = async (archivoId, ordenId) => {
        try {
            const response = await authAxios.post('/ordenes/revisar', { id: ordenId });
            if (response.data.success) {
                this.setState(prevState => {
                    const nuevosArchivos = prevState.archivos.map(arch => {
                        if (arch.id === archivoId) {
                            const nuevasOrdenes = arch.ordenes_internas.map(o => {
                                if (o.id === ordenId) {
                                    return { ...o, revisado: 'Si' };
                                }
                                return o;
                            });
                            return { ...arch, ordenes_internas: nuevasOrdenes };
                        }
                        return arch;
                    });
                    return { archivos: nuevosArchivos };
                });
                Swal.fire({ icon: 'success', title: 'Éxito', text: 'Orden revisada correctamente', timer: 1500, showConfirmButton: false });
            } else {
                this.mostrarAlerta('error', 'Error', response.data.message || 'No se pudo revisar la orden');
            }
        } catch (error) {
            this.mostrarAlerta('error', 'Error', 'Ocurrió un error al revisar la orden');
        }
    };

    facturarSeleccionadas = async () => {
        const { ordenesSeleccionadas, epsFacturacion, regimenFacturacion, planFacturacion, modalidadFacturacion, epsSeleccionada } = this.state;

        if (!epsFacturacion || !regimenFacturacion || !modalidadFacturacion || !planFacturacion) {
            this.mostrarAlerta('error', 'Error', 'Debe diligenciar todos los campos marcados con *');
            return;
        }

        if (ordenesSeleccionadas.length > 0 && epsFacturacion !== epsSeleccionada) {
            this.mostrarAlerta('error', 'Error', `La EPS seleccionada no coincide con la EPS de las órdenes (${this.getNombreEmpresa(epsSeleccionada)})`);
            return;
        }

        const result = await this.mostrarConfirmacion('¿Confirmar facturación?', `Va a facturar ${ordenesSeleccionadas.length} orden(es)`);
        if (!result.isConfirmed) return;
        
        this.cerrarModalFacturacion();
        this.setState({ facturando: true });
        this.mostrarLoading('Facturando...', 'Por favor espere');

        try {
            const response = await authAxios.post('/ordenes/facturar', {
                ids: ordenesSeleccionadas,
                eps: epsFacturacion,
                regimen: regimenFacturacion,
                plan_servicio: planFacturacion,
                modalidad_pago: modalidadFacturacion
            });

            this.cerrarLoading();

            if (response.data.status) {
                await this.mostrarAlerta('success', '¡Factura Generada!', `Factura #${response.data.factura_id} generada correctamente.`, 4000);
                this.limpiarSeleccion();
                await this.cargarArchivos(this.state.pagina_actual);
                this.setState({ facturando: false });
            } else {
                this.mostrarAlerta('error', 'Error', response.data.message || 'Error al facturar');
                this.setState({ facturando: false });
            }
        } catch (error) {
            this.cerrarLoading();
            let msg = 'No se pudieron facturar las órdenes';
            if (error.response && error.response.data) msg = error.response.data.message || msg;
            this.mostrarAlerta('error', 'Error', msg);
            this.setState({ facturando: false, showModalFacturacion: true });
        }
    };

    render() {
        const { 
            busqueda, eps, regimen, estado, fecha_desde, fecha_hasta, revisado,
            archivos, cargando, pagina_actual, ultima_pagina, total,
            ordenesSeleccionadas, epsSeleccionada, expandedRows,
            showModalOrden, ordenSeleccionada,
            showModalFacturacion, epsFacturacion, regimenFacturacion, planFacturacion, modalidadFacturacion, facturando,
            empresas, regimenes, planes, modalidades, warningMessage
        } = this.state;

        return (
            <div className="content-wrapper">
                <div className="content">
                    <div className="container-fluid">
                        <br />
                        <div className="card">
                            <div className="card-header d-flex justify-content-between align-items-center">
                                <h5 className="mb-0">
                                    <b>FACTURAR ORDENES</b>
                                </h5>
                                <div>
                                    {epsSeleccionada && (
                                        <span className="badge bg-info me-2">EPS: {this.getNombreEmpresa(epsSeleccionada)}</span>
                                    )}
                                    {ordenesSeleccionadas.length > 0 && (
                                        <button className="btn btn-warning btn-sm me-2" onClick={this.limpiarSeleccion}>
                                            <FontAwesomeIcon icon={faTimes} /> Limpiar ({ordenesSeleccionadas.length})
                                        </button>
                                    )}
                                    <button className="btn btn-success btn-sm" onClick={this.abrirModalFacturacion} disabled={ordenesSeleccionadas.length === 0}>
                                        <FontAwesomeIcon icon={faFileInvoice} /> Facturar ({ordenesSeleccionadas.length})
                                    </button>
                                </div>
                            </div>
                            
                            {warningMessage && (
                                <div className="alert alert-warning alert-dismissible fade show m-3" role="alert">
                                    <FontAwesomeIcon icon={faExclamationTriangle} className="me-2" /> {warningMessage}
                                    <button type="button" className="btn-close" onClick={() => this.setState({ warningMessage: '' })}></button>
                                </div>
                            )}

                            <div className="card-body">
                                <div className="row mb-4">
                                    <div className="col-md-12">
                                        <div className="card bg-secondary">
                                            <div className="card-body">
                                                <h6 className="mb-3">Filtros de búsqueda</h6>
                                                <div className="row">
                                                    <div className="col-md-3 mb-2">
                                                        <label>Búsqueda general</label>
                                                        <input type="text" className="form-control form-control-sm" name="busqueda" value={busqueda} onChange={this.handleFilterChange} placeholder="Orden externa, atención, paciente..." />
                                                    </div>
                                                    <div className="col-md-2 mb-2">
                                                        <label>EPS</label>
                                                        <select className="form-control form-control-sm" name="eps" value={eps} onChange={this.handleFilterChange}>
                                                            <option value="">Todas las EPS</option>
                                                            {empresas.map(emp => <option key={emp.id} value={emp.id}>{emp.nombre}</option>)}
                                                        </select>
                                                    </div>
                                                    <div className="col-md-2 mb-2">
                                                        <label>Régimen</label>
                                                        <select className="form-control form-control-sm" name="regimen" value={regimen} onChange={this.handleFilterChange}>
                                                            <option value="">Todos</option>
                                                            {regimenes.map(reg => <option key={reg.id} value={reg.codigo}>{reg.nombre}</option>)}
                                                        </select>
                                                    </div>
                                                    <div className="col-md-2 mb-2">
                                                        <label>Estado</label>
                                                        <select className="form-control form-control-sm" name="estado" value={estado} onChange={this.handleFilterChange}>
                                                            <option value="">Todos</option>
                                                            <option value="completadas">Completadas (100%)</option>
                                                            <option value="no_completadas">No Completadas</option>
                                                        </select>
                                                    </div>
                                                    <div className="col-md-2 mb-2">
                                                        <label>Revisado</label>
                                                        <select className="form-control form-control-sm" name="revisado" value={revisado} onChange={this.handleFilterChange}>
                                                            <option value="">Todos</option>
                                                            <option value="Si">Sí</option>
                                                            <option value="No">No</option>
                                                            <option value="null">Sin revisar</option>
                                                        </select>
                                                    </div>
                                                    <div className="col-md-2 mb-2">
                                                        <label>Fecha Desde</label>
                                                        <input type="date" className="form-control form-control-sm" name="fecha_desde" value={fecha_desde} onChange={this.handleFilterChange} />
                                                    </div>
                                                    <div className="col-md-2 mb-2">
                                                        <label>Fecha Hasta</label>
                                                        <input type="date" className="form-control form-control-sm" name="fecha_hasta" value={fecha_hasta} onChange={this.handleFilterChange} />
                                                    </div>
                                                    <div className="col-md-12 mt-2">
                                                        <button className="btn btn-primary btn-sm me-2" onClick={this.buscar}><FontAwesomeIcon icon={faSearch} /> Buscar</button>
                                                        <button className="btn btn-secondary btn-sm" onClick={this.limpiarFiltros}><FontAwesomeIcon icon={faTimes} /> Limpiar</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="table-responsive">
                                    <table className="table table-hover table-bordered table-sm">
                                        <thead className="table-primary">
                                            <tr>
                                                <th width="40"></th>
                                                <th>N. Archivo</th>
                                                <th>Paciente</th>
                                                <th>EPS</th>
                                                <th>Diagnóstico</th>
                                                <th>Fecha Inicial</th>
                                                <th>Fecha Final</th>
                                                <th>Cantidad</th>
                                                <th>% General</th>
                                                <th>Acciones</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {cargando ? (
                                                <tr><td colSpan="10" className="text-center"><div className="spinner-border text-primary"></div></td></tr>
                                            ) : archivos.length === 0 ? (
                                                <tr><td colSpan="10" className="text-center text-muted">No hay archivos para mostrar</td></tr>
                                            ) : (
                                                archivos.map(archivo => {
                                                    const isExpanded = expandedRows.includes(archivo.id);
                                                    return (
                                                        <React.Fragment key={archivo.id}>
                                                            <tr>
                                                                <td className="text-center" onClick={() => this.toggleRow(archivo.id)}>
                                                                    <FontAwesomeIcon icon={isExpanded ? faChevronUp : faChevronDown} style={{cursor: 'pointer'}} />
                                                                </td>
                                                                <td>{archivo.numero_archivo}</td>
                                                                <td>{archivo.nombre} {archivo.apellido} <small className="text-muted">CC: {archivo.cedula}</small></td>
                                                                <td><span className="badge bg-secondary">{this.getNombreEmpresa(archivo.eps)}</span></td>
                                                                <td>{archivo.diagnostico}</td>
                                                                <td>{archivo.fecha_inicial}</td>
                                                                <td>{archivo.fecha_final}</td>
                                                                <td className="text-center">{archivo.cantidad}</td>
                                                                <td>
                                                                    <div className="progress" style={{ height: '20px' }}>
                                                                        <div className={`progress-bar ${archivo.porcentaje_general >= 100 ? 'bg-success' : 'bg-warning'}`} style={{ width: `${archivo.porcentaje_general || 0}%` }}>
                                                                            {archivo.porcentaje_general || 0}%
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <button className="btn btn-info btn-xs text-white" onClick={() => this.verOrdenModal(archivo)} title="Ver orden completa">
                                                                        <FontAwesomeIcon icon={faEye} />
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                            {isExpanded && (
                                                                <tr>
                                                                    <td colSpan="10" className="p-3 bg-light">
                                                                        <table className="table table-sm table-bordered bg-white mb-0">
                                                                            <thead className="table-dark" style={{ color: 'white' }}>
                                                                                <tr style={{ color: 'white' }}>
                                                                                    <th width="40">Sel</th>
                                                                                    <th>ID</th>
                                                                                    <th>Orden Externa</th>
                                                                                    <th>Atención</th>
                                                                                    <th>Cantidad</th>
                                                                       
                                                                                    <th>%</th>
                                                                                    <th>Paquete</th>
                                                                                    <th>Profesional</th>
                                                                                    <th>Acciones</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody className="text-dark">
                                                                                {(archivo.ordenes_internas || []).map(ord => {
                                                                                    const seleccionada = ordenesSeleccionadas.includes(ord.id);
                                                                                    const disabled = ord.porcentaje < 100 || ord.factura > 0 || ord.revisado !== 'Si';
                                                                                    return (
                                                                                        <tr key={ord.id} className={seleccionada ? 'table-primary text-dark' : 'text-dark'}>
                                                                                            <td className="text-center">
                                                                                                <input 
                                                                                                    type="checkbox" 
                                                                                                    checked={seleccionada}
                                                                                                    disabled={disabled && !seleccionada}
                                                                                                    onChange={() => this.toggleSeleccionOrden(ord.id, archivo.eps, ord.porcentaje)}
                                                                                                />
                                                                                            </td>
                                                                                            <td className="text-dark">{ord.id}</td>
                                                                                            <td className="text-dark">{ord.orden_externa}</td>
                                                                                            <td className="text-dark">{ord.atencion}</td>
                                                                                            <td className="text-center text-dark">{ord.cantidad}</td>
                                                                                         
                                                                                            <td>
                                                                                                <span className={`badge ${ord.porcentaje >= 100 ? 'bg-success' : 'bg-danger'}`}>
                                                                                                    {ord.porcentaje}%
                                                                                                </span>
                                                                                            </td>
                                                                                            <td className="text-dark">{ord.paquete}</td>
                                                                                            <td className="text-dark">{ord.profesional}</td>
                                                                                            <td className="text-center">
                                                                                                {ord.porcentaje >= 100 && ord.revisado !== 'Si' && !ord.factura ? (
                                                                                                    <button 
                                                                                                        className="btn btn-danger btn-xs" 
                                                                                                        onClick={() => this.revisarOrden(archivo.id, ord.id)} 
                                                                                                        title="Revisar Orden"
                                                                                                    >
                                                                                                        <FontAwesomeIcon icon={faClipboardCheck} /> Revisar
                                                                                                    </button>
                                                                                                ) : ord.revisado === 'Si' ? (
                                                                                                    <span className="badge bg-success"><FontAwesomeIcon icon={faClipboardCheck} /> Revisada</span>
                                                                                                ) : null}
                                                                                            </td>
                                                                                        </tr>
                                                                                    )
                                                                                })}
                                                                                {(!archivo.ordenes_internas || archivo.ordenes_internas.length === 0) && (
                                                                                    <tr><td colSpan="9" className="text-center">No hay órdenes sin facturar en este archivo.</td></tr>
                                                                                )}
                                                                            </tbody>
                                                                        </table>
                                                                    </td>
                                                                </tr>
                                                            )}
                                                        </React.Fragment>
                                                    );
                                                })
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                                {!cargando && archivos.length > 0 && (
                                    <div className="d-flex justify-content-between align-items-center mt-3">
                                        <div>Mostrando {archivos.length} de {total} registros</div>
                                        <div>
                                            <button className="btn btn-sm btn-outline-primary me-2" onClick={() => this.cambiarPagina(pagina_actual - 1)} disabled={pagina_actual === 1}><FontAwesomeIcon icon={faChevronLeft} /> Anterior</button>
                                            <span className="mx-2">Página {pagina_actual} de {ultima_pagina}</span>
                                            <button className="btn btn-sm btn-outline-primary ms-2" onClick={() => this.cambiarPagina(pagina_actual + 1)} disabled={pagina_actual === ultima_pagina}>Siguiente <FontAwesomeIcon icon={faChevronRight} /></button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Modal de facturación */}
                {showModalFacturacion && (
                    <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1070 }} tabIndex="-1">
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Facturar {ordenesSeleccionadas.length} orden(es)</h5>
                                    <button type="button" className="btn-close" onClick={this.cerrarModalFacturacion} disabled={facturando}></button>
                                </div>
                                <div className="modal-body">
                                    <div className="mb-3">
                                        <label className="form-label">EPS a facturar <span className="text-danger">*</span></label>
                                        <select className="form-control form-control-sm" value={epsFacturacion} onChange={this.handleEpsFacturacionChange} disabled={facturando}>
                                            <option value="">Seleccione una EPS</option>
                                            {empresas.map(emp => <option key={emp.id} value={emp.id}>{emp.nombre}</option>)}
                                        </select>
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Régimen a facturar <span className="text-danger">*</span></label>
                                        <select className="form-control form-control-sm" value={regimenFacturacion} onChange={(e) => this.setState({ regimenFacturacion: e.target.value })} disabled={facturando}>
                                            <option value="">Seleccione un régimen</option>
                                            {regimenes.map(reg => <option key={reg.id} value={reg.codigo}>{reg.nombre}</option>)}
                                        </select>
                                    </div>
                                    <div className="row mb-3">
                                        <div className="col-md-6">
                                            <label className="form-label">Modalidad de Pago <span className="text-danger">*</span></label>
                                            <select className="form-control form-control-sm" value={modalidadFacturacion} onChange={(e) => this.setState({ modalidadFacturacion: e.target.value })} disabled={facturando}>
                                                <option value="">Seleccione</option>
                                                {modalidades.map(mod => <option key={mod.id} value={mod.id || mod.codigo}>{mod.nombre}</option>)}
                                            </select>
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label">Plan de Servicio <span className="text-danger">*</span></label>
                                            <select className="form-control form-control-sm" value={planFacturacion} onChange={(e) => this.setState({ planFacturacion: e.target.value })} disabled={facturando}>
                                                <option value="">Seleccione</option>
                                                {planes.map(pl => <option key={pl.id} value={pl.id || pl.codigo}>{pl.nombre}</option>)}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-success" onClick={this.facturarSeleccionadas} disabled={facturando || (epsSeleccionada && epsFacturacion !== epsSeleccionada)}>
                                        {facturando ? "Facturando..." : <><FontAwesomeIcon icon={faFileInvoice} /> Confirmar Facturación</>}
                                    </button>
                                    <button type="button" className="btn btn-secondary" onClick={this.cerrarModalFacturacion} disabled={facturando}>Cancelar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Modal de ver orden (archivo completo) */}
                {showModalOrden && ordenSeleccionada && (
                    <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1060 }} tabIndex="-1">
                        <div className="modal-dialog modal-fullscreen modal-dialog-scrollable">
                            <div className="modal-content" style={{ minHeight: '90vh' }}>
                                <div className="modal-header bg-light">
                                    <h5 className="modal-title">
                                        Detalle de Archivo #{ordenSeleccionada.numero_archivo || ordenSeleccionada.id} - {ordenSeleccionada.nombre} {ordenSeleccionada.apellido}
                                    </h5>
                                    <button type="button" className="btn-close" onClick={this.cerrarModalOrden}></button>
                                </div>
                                <div className="modal-body p-0">
                                    <Ordenes />
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default FacturarArchivo;